import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  animation: ShadeIn 0.7s linear;
  @keyframes ShadeIn {
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
`;

export const Part = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent linear-gradient(180deg, #7c2280 0%, #2d1641 100%) 0%
    0% no-repeat padding-box;
  > img {
    padding: 20px;
    width: 250px;
  }
`;

export const ContainerCard = styled.div`
  width: 450px;
  @media (max-width: 768px) {
    width: 350px;
  }
  @media (max-width: 425px) {
    width: 300px;
  }
`;
